module.exports = __webpack_public_path__ + "static/img/ic_certificate_b.929d7a09.png";